import { TFunction } from "i18next";
import { APP_DOMAIN, APP_NAME } from "../../utls/constants";

const useIntroPageInfos = (t: TFunction) => {
  const pageTitle = `${t("main-page-title")} | ${APP_NAME}`;
  const pageDescription = t("main-page-description");

  document.title = pageTitle;

  let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = pageDescription;

  document.querySelectorAll('link[rel="canonical"]').forEach((link) => link.remove());
  const linkCanonical = document.createElement("link");
  linkCanonical.rel = "canonical";
  linkCanonical.href = `https://www.${APP_DOMAIN}/auth/intro`;
  document.head.appendChild(linkCanonical);

  let metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement;
  if (!metaRobots) {
    metaRobots = document.createElement("meta");
    metaRobots.name = "robots";
    document.head.appendChild(metaRobots);
  }
  metaRobots.content = "index, follow";

  let scriptJsonLd = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
  if (!scriptJsonLd) {
    scriptJsonLd = document.createElement("script");
    scriptJsonLd.type = "application/ld+json";
    document.head.appendChild(scriptJsonLd);
  }
  scriptJsonLd.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: pageTitle,
    url: `https://www.${APP_DOMAIN}/auth/intro`,
    description: pageDescription,
    isPartOf: {
      "@type": "WebSite",
      name: APP_NAME,
      url: `https://www.${APP_DOMAIN}`,
    },
  });

  const metaOgTags = [
    { property: "og:title", content: pageTitle },
    { property: "og:description", content: pageDescription },
    { property: "og:url", content: `https://www.${APP_DOMAIN}/auth/intro` },
    { property: "og:type", content: "website" },
  ];

  metaOgTags.forEach((tag) => {
    let metaTag = document.querySelector(`meta[property="${tag.property}"]`) as HTMLMetaElement;
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("property", tag.property);
      document.head.appendChild(metaTag);
    }
    metaTag.content = tag.content;
  });

  return () => {
    document.title = APP_NAME;
    metaDescription.content = t("app_description", { appName: APP_NAME });
    linkCanonical.remove();
    scriptJsonLd.remove();
    metaRobots.content = "";
  };
};

export default useIntroPageInfos;
